// Default error types available for all eligible forms
export const defaultDeMinimisErrorTypes = [
    { value: "spelling-error", label: "Spelling error" },
    { value: "date-error", label: "Date or time error" },
    { value: "name-error", label: "Name incorrect" },
    { value: "address-error", label: "Address incorrect" },
    { value: "numerical-error", label: "Numerical error" },
    { value: "other", label: "Other" },
];
// H3-specific error types (Record of detention)
const h3ErrorTypes = [
    {
        value: "incorrect-admission-datetime",
        label: "Admission date/time incorrect",
    },
    { value: "incorrect-hospital-name", label: "Hospital name incorrect" },
    { value: "spelling-error", label: "Spelling error" },
    { value: "name-error", label: "Name incorrect" },
    { value: "address-error", label: "Address incorrect" },
    { value: "date-error", label: "Date or time error" },
    { value: "numerical-error", label: "Numerical error" },
    { value: "other", label: "Other" },
];
// CTO-specific error types
const ctoErrorTypes = [
    {
        value: "incorrect-patient-details",
        label: "Patient name or address incorrect",
    },
    {
        value: "incorrect-responsible-clinician",
        label: "Responsible clinician details incorrect",
    },
    { value: "incorrect-hospital-name", label: "Hospital name incorrect" },
    { value: "spelling-error", label: "Spelling error" },
    { value: "date-error", label: "Date or time error" },
    { value: "address-error", label: "Address incorrect" },
    { value: "numerical-error", label: "Numerical error" },
    { value: "other", label: "Other" },
];
// Treatment form-specific error types (T2, T4)
const treatmentErrorTypes = [
    {
        value: "incorrect-patient-details",
        label: "Patient name or address incorrect",
    },
    {
        value: "incorrect-treatment-description",
        label: "Treatment description incorrect",
    },
    {
        value: "incorrect-clinician-details",
        label: "Clinician details incorrect",
    },
    { value: "spelling-error", label: "Spelling error" },
    { value: "date-error", label: "Date or time error" },
    { value: "numerical-error", label: "Numerical error" },
    { value: "other", label: "Other" },
];
/**
 * Per-template error type overrides. If a template ID is not in this map,
 * the `defaultDeMinimisErrorTypes` are used as a fallback.
 */
const templateErrorTypeOverrides = {
    "mha-h3": h3ErrorTypes,
    "mha-cto1": ctoErrorTypes,
    "mha-cto2": ctoErrorTypes,
    "mha-cto3": ctoErrorTypes,
    "mha-cto4": ctoErrorTypes,
    "mha-cto5": ctoErrorTypes,
    "mha-cto6": ctoErrorTypes,
    "mha-cto7": ctoErrorTypes,
    "mha-cto8": ctoErrorTypes,
    "mha-cto9": ctoErrorTypes,
    "mha-cto10": ctoErrorTypes,
    "mha-cto12": ctoErrorTypes,
    "mha-s62": treatmentErrorTypes,
    "mha-t2": treatmentErrorTypes,
    "mha-t4": treatmentErrorTypes,
};
/**
 * Get the de minimis error types for a given form template.
 * Returns template-specific error types if available, otherwise the defaults.
 */
export function getDeMinimisErrorTypes(templateId) {
    return templateErrorTypeOverrides[templateId] ?? defaultDeMinimisErrorTypes;
}
//# sourceMappingURL=deMinimisErrorTypes.js.map